export const quizzes = [
  //&&&& quiz ----------------> 1
  {
    quiz_text: "What is the colour of the tag use in certified seed bag?",
    quiz_avatar: "",
    correctAnswer: "Blue",
    options: [
      {
        option_avatar: "/sep-images/1.png",
        option_label: "Blue",
      },
      {
        option_avatar: "/sep-images/2.png",
        option_label: "Purple",
      },
      {
        option_avatar: "/sep-images/3.png",
        option_label: "White",
      },
      {
        option_avatar: "/sep-images/4.png",
        option_label: "Golden Yellow",
      },
    ],
  },

  //&&&& quiz ----------------> 2
  {
    quiz_text: `Who won the 2024 United States presidential election ?`,
    quiz_avatar: "",
    correctAnswer: "Donald Trump",
    options: [
      {
        option_avatar: "",
        option_label: "Kamala Harris",
      },
      {
        option_avatar: "",
        option_label: "Donald Trump",
      },
      {
        option_avatar: "",
        option_label: "Joe Biden",
      },
      { option_avatar: "", option_label: "Barack Obama" },
    ],
  },

  //&&&& quiz ----------------> 3
  {
    quiz_text: "What is the main purpose of crop rotation?",
    quiz_avatar: "",
    correctAnswer: "To reduce pest and disease buildup",
    options: [
      {
        option_avatar: "",
        option_label: "To increase crop yield",
      },
      {
        option_avatar: "",
        option_label: "To prevent soil erosion",
      },
      { option_avatar: "", option_label: "To reduce pest and disease buildup" },
      {
        option_avatar: "",
        option_label: "To improve water retention in soil",
      },
    ],
  },

  //&&&& quiz ----------------> 4
  {
    quiz_text: `Which is the apex banking institution for providing finance for Agriculture and Rural development in India?`,
    quiz_avatar: "",
    correctAnswer: "NABARD",
    options: [
      {
        option_avatar: "",
        option_label: "RBI",
      },
      {
        option_avatar: "",
        option_label: "NABARD",
      },
      {
        option_avatar: "",
        option_label: "SEBI",
      },
      {
        option_avatar: "",
        option_label: "IBRD",
      },
    ],
  },

  //&&&& quiz ----------------> 5
  {
    quiz_text:
      "What do we call the stock of food grains purchased by the Government of India from the farmers through the Food Corporation of India (FCI)?",
    quiz_avatar: "",
    correctAnswer: "Buffer stock",
    options: [
      {
        option_avatar: "",
        option_label: "Incentivized stock",
      },
      {
        option_avatar: "",
        option_label: "Return stock",
      },
      {
        option_avatar: "",
        option_label: "Subsidized stock",
      },
      {
        option_avatar: "",
        option_label: "Buffer stock",
      },
    ],
  },

  //&&&& quiz ----------------> 6
  {
    quiz_text: `Which state has the highest AQI in India?`,
    quiz_avatar: "",
    correctAnswer: "Delhi",
    options: [
      { option_avatar: "", option_label: "Rohtak" },
      {
        option_avatar: "",
        option_label: "Noida",
      },
      {
        option_avatar: "",
        option_label: "Delhi",
      },
      {
        option_avatar: "",
        option_label: "Ghaziabad",
      },
    ],
  },

  //&&&& quiz ----------------> 7
  {
    quiz_text: `When is World Soil Day celebrated?`,
    quiz_avatar: "",
    correctAnswer: "5th December",
    options: [
      {
        option_avatar: "",
        option_label: "10th January",
      },
      {
        option_avatar: "",
        option_label: "5th November",
      },
      {
        option_avatar: "",
        option_label: "15th November",
      },
      {
        option_avatar: "",
        option_label: "5th December",
      },
    ],
  },

  //&&&& quiz ----------------> 8
  {
    quiz_text: "The Pradhan Mantri Fasal Bima Yojana (PMFBY) is related to:",
    quiz_avatar: "",
    correctAnswer: "Crop Insurance",
    options: [
      { option_avatar: "", option_label: "Soil Health Management" },
      { option_avatar: "", option_label: "Crop Insurance" },
      { option_avatar: "", option_label: "Agricultural Subsidies" },
      { option_avatar: "", option_label: "Organic Farming" },
    ],
  },

  //&&&& quiz ----------------> 9
  {
    quiz_text:
      "Which irrigation method is most commonly used in India for agriculture?",
    quiz_avatar: "",
    correctAnswer: "Canal irrigation",
    options: [
      {
        option_avatar: "",
        option_label: "Sprinkler irrigation",
      },
      {
        option_avatar: "",
        option_label: "Drip irrigation",
      },
      {
        option_avatar: "",
        option_label: "Canal irrigation",
      },
      {
        option_avatar: "",
        option_label: "Rainfed irrigation",
      },
    ],
  },

  //&&&& quiz ----------------> 10
  {
    quiz_text: "Who was the first Indian Agricultural Minister?",
    quiz_avatar: "",
    correctAnswer: "Dr Rajendra Prasad",
    options: [
      {
        option_avatar: "",
        option_label: "Dr Rajendra Prasad",
      },
      {
        option_avatar: "",
        option_label: "Pandit Jawahar Lal Nehru",
      },
      {
        option_avatar: "",
        option_label: "Chidambaram Subramaniam",
      },
      {
        option_avatar: "",
        option_label: "Bhimrao Ramji Ambedkar",
      },
    ],
  },
];

export const UserCardData = [
  {
    image: "/images/capa-1.svg",
    name_title: "392+",
    disc: "Products",
    id: "01",
  },
  {
    image: "/images/capa-2.svg",
    name_title: "1700+",
    disc: "Employee Strength",
    id: "02",
  },
  {
    image: "/images/capa-3.svg",
    name_title: "5000+",
    disc: "Distributors",
    id: "03",
  },
  {
    image: "/images/capa-4.svg",
    name_title: "60000+",
    disc: "Retailers",
    id: "04",
  },
];
export const FarmerCardData = [
  {
    image: "/images/f-2.png",
    name_title: "Swami",
    disc: "On our farms, we grow three vital crops: Paddy, Cotton, and Corn. We value Nuziveedu for its low labor charges, which greatly benefit us and our fellow farmers. On completing 50 successful years, we extend our heartfelt gratitude on behalf of all the farmer brothers and myself.",
    id: "01",
    bio: "Telangana",
  },
  {
    image: "/images/f-1.png",
    name_title: "Ram Reddy",
    disc: "The role of seeds in agriculture is very important. If the seeds are good then the yield will be high. Nuziveedu Seeds is known for providing quality seeds and offering support to farmers. Their proactive approach including field visits to address any concerns is commendable and ensures effective problem-solving. We thank Nuziveedu Seeds for their invaluable contribution to farming success.    ",
    id: "02",
    bio: "Telangana",
  },
  {
    image: "/images/f-2.png",
    name_title: "Swami",
    disc: "On our farms, we grow three vital crops: Paddy, Cotton, and Corn. We value Nuziveedu for its low labor charges, which greatly benefit us and our fellow farmers. On completing 50 successful years, we extend our heartfelt gratitude on behalf of all the farmer brothers and myself.",
    id: "01",
    bio: "Telangana",
  },
  {
    image: "/images/f-1.png",
    name_title: "Ram Reddy",
    disc: "The role of seeds in agriculture is very important. If the seeds are good then the yield will be high. Nuziveedu Seeds is known for providing quality seeds and offering support to farmers. Their proactive approach including field visits to address any concerns is commendable and ensures effective problem-solving. We thank Nuziveedu Seeds for their invaluable contribution to farming success.",
    id: "02",
    bio: "Telangana",
  },
];
export const yearsData = [
  {
    image: "/icons/icon-1.svg",
    name_title: "Inception by the Visionary Sri Venkat Ramaiah Garu",
    disc: "A humble beginning that laid the foundation for something extraordinary.",
    year: "1973",
  },
  {
    image: "/icons/icon-2.svg",
    name_title: "Transformation by Mr. M Prabhakar Rao Garu",
    disc: "A visionary's legacy continued, steering Nuziveedu into new realms of success.",
    year: "1982",
  },
  {
    image: "/icons/icon-3.svg",
    name_title: "Milestone - Turnover reaches 100 Crores",
    disc: "A significant achievement that marked the first of many triumphs",
    year: "1995",
  },
  {
    image: "/icons/icon-10.svg",
    name_title: "",
    disc: (
      <>
        Hybrid Cotton Bunny Notified by Government
        <br />
        <br />
        Hybrid Cotton Mallika Notified by Government{" "}
      </>
    ),
    year: "2001-03",
  },
  {
    image: "/icons/icon-11.svg",
    name_title: "DSIR Award",
    disc: (
      <>
        towards best R&D efforts in cotton for Bunny and Mallika in the Indian
        Seed Industry <br />
        <br />
      </>
    ),
    year: "2002",
  },
  {
    image: "/icons/icon-10.svg",
    name_title: "",
    disc: (
      <>
        2005 - Bunny & Malika BT-1 Launch <br />
        2006 - Bunny & Malika BT-2 Launch <br />
        2007 - Seed testing lab established at Kompally, TS, accredited by ISTA
      </>
    ),
    year: "2005-07",
  },
  {
    image: "/icons/icon-6.svg",
    name_title: "",
    disc: "Leadership awards received for two consecutive years",
    year: "2008-09",
  },
  {
    image: "/icons/icon-12.svg",
    name_title: "",
    disc: "Block buster research paddy Sourabh & Moti launched",
    year: "2010",
  },
  {
    image: "/icons/icon-10.svg",
    name_title: "",
    disc: "Hybrid BT-2 cotton Bhakti launched",
    year: "2012",
  },
  {
    image: "/icons/icon-7.svg",
    name_title: "Plan - Turnover crosses 1000+ Crore",
    disc: "2012 - Acquired PABL, FHSL, AAGL 2013 - Acquired GAPL",
    year: "2012-13",
  },
  {
    image: "/icons/icon-8.svg",
    name_title: "Plan - Turnover crosses 1000+ Crore",
    disc: "Setting our sights higher, aspiring for even greater heights of success.",
    year: "2022-23",
  },
  {
    image: "/icons/icon-14.svg",
    name_title: "Nuziveedu Celebrates 50 Years of Existence",
    disc: "Half a century of excellence, innovation, and commitment to the future.",
    year: "2024",
  },
];

export const socialLinks = [
  {
    icon: (
      <>
        <svg
          width="41"
          height="41"
          viewBox="0 0 41 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M41 20.5C41 9.17793 31.8221 0 20.5 0C9.17793 0 0 9.17793 0 20.5C0 30.7318 7.49541 39.2142 17.2959 40.751V26.4253H12.0904V20.5H17.2959V15.9839C17.2959 10.8453 20.3573 8.00867 25.0404 8.00867C27.2847 8.00867 29.6293 8.40956 29.6293 8.40956V13.4541H27.0448C24.4998 13.4541 23.7041 15.0333 23.7041 16.6551V20.5H29.3894L28.4813 26.4253H23.7041V40.751C33.5046 39.2142 41 30.7318 41 20.5Z"
            fill="#ED3438"
          />
          <path
            d="M28.4783 26.4251L29.3864 20.4999H23.701V16.655C23.701 15.0332 24.4937 13.454 27.0418 13.454H29.6263V8.40943C29.6263 8.40943 27.2817 8.00854 25.0373 8.00854C20.3542 8.00854 17.2929 10.8451 17.2929 15.9838V20.4999H12.0874V26.4251H17.2929V40.7508C18.3376 40.9148 19.4067 40.9999 20.497 40.9999C21.5873 40.9999 22.6563 40.9148 23.701 40.7508V26.4251H28.4783Z"
            fill="white"
          />
        </svg>
      </>
    ),
    address: "https://www.facebook.com/nuziveeduseedslimited/",
  },
  {
    icon: (
      <>
        <svg
          width="41"
          height="41"
          viewBox="0 0 41 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.5 41C31.8218 41 41 31.8218 41 20.5C41 9.17816 31.8218 0 20.5 0C9.17817 0 0 9.17816 0 20.5C0 31.8218 9.17817 41 20.5 41Z"
            fill="#ED3438"
          />
          <path
            d="M20.5 9.9189C23.947 9.9189 24.354 9.93105 25.7146 9.99483C26.9719 10.0525 27.6552 10.2621 28.1108 10.4382C28.7121 10.6721 29.1434 10.9515 29.5959 11.404C30.0484 11.8565 30.3278 12.2848 30.5617 12.8891C30.7378 13.3447 30.9474 14.028 31.0051 15.2853C31.0658 16.6459 31.081 17.0559 31.081 20.4999C31.081 23.9439 31.0689 24.3539 31.0051 25.7145C30.9474 26.9719 30.7378 27.6552 30.5617 28.1108C30.3278 28.7121 30.0484 29.1433 29.5959 29.5959C29.1434 30.0484 28.7152 30.3278 28.1108 30.5616C27.6552 30.7378 26.9719 30.9473 25.7146 31.005C24.354 31.0658 23.947 31.081 20.5 31.081C17.0529 31.081 16.646 31.0688 15.2854 31.005C14.0281 30.9473 13.3447 30.7378 12.8892 30.5616C12.2878 30.3278 11.8566 30.0484 11.4041 29.5959C10.9515 29.1433 10.6721 28.7151 10.4383 28.1108C10.2621 27.6552 10.0526 26.9719 9.99487 25.7145C9.93413 24.3539 9.91894 23.9439 9.91894 20.4999C9.91894 17.0559 9.93109 16.6459 9.99487 15.2853C10.0526 14.028 10.2621 13.3447 10.4383 12.8891C10.6721 12.2878 10.9515 11.8565 11.4041 11.404C11.8566 10.9515 12.2848 10.6721 12.8892 10.4382C13.3447 10.2621 14.0281 10.0525 15.2854 9.99483C16.646 9.93408 17.056 9.9189 20.5 9.9189ZM20.5 7.59253C16.9952 7.59253 16.5549 7.60771 15.1791 7.67149C13.8063 7.73527 12.8679 7.9509 12.0449 8.27283C11.1975 8.60386 10.4778 9.04423 9.75798 9.76097C9.04124 10.4777 8.59783 11.1975 8.26983 12.0479C7.95094 12.8679 7.73227 13.8063 7.6685 15.1821C7.60472 16.5579 7.58954 16.9982 7.58954 20.503C7.58954 24.0077 7.60472 24.4481 7.6685 25.8239C7.73227 27.1966 7.94791 28.135 8.26983 28.9581C8.60087 29.8054 9.04124 30.5252 9.75798 31.245C10.4747 31.9617 11.1945 32.4051 12.0449 32.7331C12.8649 33.052 13.8033 33.2707 15.1791 33.3345C16.5549 33.3982 16.9952 33.4134 20.5 33.4134C24.0047 33.4134 24.4451 33.3982 25.8209 33.3345C27.1936 33.2707 28.132 33.055 28.9551 32.7331C29.8024 32.4021 30.5222 31.9617 31.242 31.245C31.9587 30.5282 32.4021 29.8085 32.7301 28.9581C33.049 28.1381 33.2677 27.1996 33.3315 25.8239C33.3952 24.4481 33.4104 24.0077 33.4104 20.503C33.4104 16.9982 33.3952 16.5579 33.3315 15.1821C33.2677 13.8093 33.052 12.8709 32.7301 12.0479C32.3991 11.2005 31.9587 10.4808 31.242 9.76097C30.5252 9.04423 29.8055 8.60083 28.9551 8.27283C28.1351 7.95394 27.1966 7.73527 25.8209 7.67149C24.4451 7.60771 24.0047 7.59253 20.5 7.59253Z"
            fill="white"
          />
          <path
            d="M20.5 13.873C16.8404 13.873 13.8732 16.8402 13.8732 20.4999C13.8732 24.1595 16.8404 27.1267 20.5 27.1267C24.1596 27.1267 27.1268 24.1595 27.1268 20.4999C27.1268 16.8402 24.1596 13.873 20.5 13.873ZM20.5 24.8033C18.125 24.8033 16.1965 22.8779 16.1965 20.4999C16.1965 18.1219 18.122 16.1964 20.5 16.1964C22.878 16.1964 24.8035 18.1219 24.8035 20.4999C24.8035 22.8779 22.878 24.8033 20.5 24.8033Z"
            fill="white"
          />
          <path
            d="M27.391 15.1578C28.2464 15.1578 28.9399 14.4644 28.9399 13.6089C28.9399 12.7535 28.2464 12.0601 27.391 12.0601C26.5356 12.0601 25.8421 12.7535 25.8421 13.6089C25.8421 14.4644 26.5356 15.1578 27.391 15.1578Z"
            fill="white"
          />
        </svg>
      </>
    ),
    address: "https://www.instagram.com/nuziveedu_seeds_limited/?hl=en",
  },
  {
    icon: (
      <>
        <svg
          width="41"
          height="41"
          viewBox="0 0 41 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.5 41C31.8218 41 41 31.8218 41 20.5C41 9.17816 31.8218 0 20.5 0C9.17817 0 0 9.17816 0 20.5C0 31.8218 9.17817 41 20.5 41Z"
            fill="#ED3438"
          />
          <path
            d="M33.5957 13.9218C33.2829 12.7465 32.3566 11.8202 31.1782 11.5043C29.0462 10.9333 20.5 10.9333 20.5 10.9333C20.5 10.9333 11.9538 10.9333 9.8218 11.5043C8.64646 11.8202 7.72016 12.7434 7.40431 13.9218C6.83334 16.0538 6.83334 20.5 6.83334 20.5C6.83334 20.5 6.83334 24.9462 7.40431 27.0782C7.71712 28.2536 8.64343 29.1799 9.8218 29.4957C11.9538 30.0667 20.5 30.0667 20.5 30.0667C20.5 30.0667 29.0462 30.0667 31.1782 29.4957C32.3536 29.1799 33.2799 28.2566 33.5957 27.0782C34.1667 24.9462 34.1667 20.5 34.1667 20.5C34.1667 20.5 34.1667 16.0538 33.5957 13.9218ZM17.7667 24.6V16.4L24.8673 20.5L17.7667 24.6Z"
            fill="white"
          />
        </svg>
      </>
    ),
    address: "https://www.youtube.com/@nuziveeduseedslimited",
  },
  {
    icon: (
      <>
        <svg
          width="41"
          height="41"
          viewBox="0 0 41 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.5 41C31.8218 41 41 31.8218 41 20.5C41 9.17816 31.8218 0 20.5 0C9.17816 0 0 9.17816 0 20.5C0 31.8218 9.17816 41 20.5 41Z"
            fill="#ED3438"
          />
          <path
            d="M22.0853 17.7028C22.4225 17.3232 22.6988 16.9405 23.0451 16.6155C24.108 15.6133 25.3653 15.1092 26.8353 15.1213C27.6431 15.1274 28.4388 15.1851 29.2163 15.4098C30.996 15.9231 32.0286 17.15 32.5237 18.8872C32.8942 20.1901 32.961 21.5295 32.964 22.8718C32.9701 25.7023 32.9549 28.5359 32.964 31.3664C32.964 31.6306 32.8911 31.7005 32.6299 31.7005C31.1722 31.6883 29.7114 31.6883 28.2536 31.7005C27.9954 31.7005 27.9408 31.6246 27.9408 31.3816C27.9499 28.6878 27.9499 25.9939 27.9408 23.297C27.9408 22.6228 27.8952 21.9455 27.7069 21.2895C27.3576 20.0808 26.4921 19.4643 25.2256 19.5311C23.4945 19.6222 22.5956 20.4786 22.3769 22.2371C22.3253 22.6562 22.2979 23.0783 22.301 23.5005C22.301 26.1215 22.301 28.7424 22.3071 31.3634C22.3071 31.6246 22.2433 31.7005 21.976 31.7005C20.5061 31.6883 19.0362 31.6883 17.5662 31.7005C17.3294 31.7005 17.2625 31.6398 17.2625 31.3998C17.2686 26.2126 17.2686 21.0223 17.2625 15.835C17.2625 15.5769 17.3476 15.5192 17.5905 15.5192C18.9845 15.5283 20.3816 15.5313 21.7756 15.5192C22.0337 15.5192 22.0975 15.6012 22.0945 15.8441C22.0793 16.4637 22.0884 17.0832 22.0884 17.7058L22.0853 17.7028Z"
            fill="#FEFEFE"
          />
          <path
            d="M14.0919 23.6311C14.0919 26.1974 14.0888 28.7637 14.0979 31.33C14.0979 31.6154 14.0281 31.7005 13.7335 31.6975C12.2757 31.6823 10.818 31.6853 9.35714 31.6975C9.12329 31.6975 9.05344 31.6397 9.05344 31.3998C9.05951 26.2034 9.05951 21.0071 9.05344 15.8077C9.05344 15.592 9.10506 15.5161 9.33284 15.5161C10.8119 15.5252 12.2909 15.5283 13.77 15.5161C14.0554 15.5161 14.0919 15.6224 14.0919 15.8684C14.0858 18.456 14.0888 21.0435 14.0888 23.6311H14.0919Z"
            fill="#FEFEFE"
          />
          <path
            d="M14.4928 10.3684C14.4928 11.9811 13.1868 13.2931 11.5772 13.2931C9.98883 13.2931 8.67077 11.9811 8.66469 10.3927C8.65862 8.78913 9.97669 7.46802 11.5833 7.46802C13.1777 7.46802 14.4897 8.77698 14.4928 10.3653V10.3684Z"
            fill="#FEFEFE"
          />
        </svg>
      </>
    ),
    address: "https://www.linkedin.com/company/nuziveedu-seeds-limited/",
  },
];

export const employeesData = [
  {
    avatar: "/images/em-1.png",
    userName: "Dr. P Sateesh Kumar",
    disc: "Digital initiatives have propelled progress for the betterment of our farmers, marking a transformative era in the world of agriculture.    ",
    bio: "Whole Time Director",
  },
  {
    avatar: "/images/em-2.png",
    userName: "Padmayyar Cherukella",
    disc: "In our pursuit of excellence, everyone at Nuziveedu works tirelessly to deliver the best quality seeds.",
    bio: "Processing",
  },
  {
    avatar: "/images/em-3.png",
    userName: "Sharad Khurana",
    disc: "Being the first seed company to supply and provide about one crore packets to farmers, Nuziveedu has become synonymous with trust, growth, and prosperity.",
    bio: "Chief Strategy Officer",
  },
  {
    avatar: "/images/em-4.png",
    userName: "Ch Appa Rao",
    disc: "Grateful to be part of a company that has earned trust and success over five decades in the agricultural landscape.",
    bio: "Director",
  },
  {
    avatar: "/images/em-5.png",
    userName: "Ramya Doppalapudi",
    disc: "In our biotech lab, we craft the seeds of tomorrow, shaping a better future for agriculture.",
    bio: "Jr. Scientist, Biotechnology",
  },
  {
    avatar: "/images/em-6.png",
    userName: "Kollipara Venkat Rao",
    disc: "Our expanding Nuziveedu team operates with excellence, driving our vision forward as we complete 50 fruitful years at Nuziveedu Seeds.",
    bio: "Chief Operating Officer",
  },
  {
    avatar: "/images/em-7.png",
    userName: "Shrikanth Vetcha",
    disc: "Proud and grateful for the incredible journey of Nuziveedu, a testament to dedication and resilience.",
    bio: "Chief Financial Officer",
  },
  {
    avatar: "/images/em-8.png",
    userName: "Mandava Asha Priya",
    disc: "Nuziveedu's success is a tribute to the dedication and passion of our dynamic team.",
    bio: "Director",
  },
  {
    avatar: "/images/em-9.png",
    userName: "Pradeep Tiwari",
    disc: "The youthful spirit of the Nuziveedu team has been instrumental in our journey of accomplishments.",
    bio: "Marketing",
  },
  {
    avatar: "/images/em-10.png",
    userName: "Krishan Chaudhary",
    disc: "The great teamwork, from dynamic sales team to innovative marketing team, has been the secret behind Nuziveedu's enduring success.",
    bio: "Business Head",
  },
  {
    avatar: "/images/em-11.png",
    userName: "Sanjay Gulati",
    disc: "Over 50 years, we've earned farmers' trust, a testament to the dedication of our entire team.",
    bio: "Business Head",
  },
  {
    avatar: "/images/em-12.png",
    userName: "K Chandrashekhar",
    disc: "I started at Nuziveedu Seeds as a Data Entry Operator in Guntur. Now, I'm proud to be promoted to Senior Manager in the Tax Department. Celebrating 50 years in the seed industry is a remarkable milestone for our esteemed company!",
    bio: "Taxation",
  },
];

export const allImages = [
  {
    image: "/years/EXP0000-71.jpg",
  },
  {
    image: "/life/nsl-2.jpeg",
  },
  {
    image: "/years/EXP0000-108.jpg",
  },
  {
    image: "/life/nsl-3.jpeg",
  },
  {
    image: "/years/EXP0000-110.jpg",
  },
  {
    image: "/years/EXP0000-112.jpg",
  },
  {
    image: "/life/nsl-1.jpeg",
  },
  {
    image: "/years/EXP0000-138.jpg",
  },
  {
    image: "/life/nsl.jpeg",
  },
  {
    image: "/years/EXP0000-149.jpg",
  },
  {
    image: "/life/nsl-4.jpeg",
  },
  {
    image: "/years/EXP0000-291.jpg",
  },
  {
    image: "/years/EXP0000-293.jpg",
  },
  {
    image: "/years/EXP0000-344.jpg",
  },
  {
    image: "/field/Untitled00086464.jpg",
  },
  {
    image: "/field/Untitled00086520.jpg",
  },
  {
    image: "/field/Untitled00086549.jpg",
  },
  {
    image: "/field/Untitled00087015.jpg",
  },
  {
    image: "/field/Untitled00087113.jpg",
  },
];

export const yearsImages = [
  {
    image: "/years/EXP0000-71.jpg",
  },
  {
    image: "/years/EXP0000-108.jpg",
  },
  {
    image: "/years/EXP0000-110.jpg",
  },
  {
    image: "/years/EXP0000-112.jpg",
  },
  {
    image: "/years/EXP0000-138.jpg",
  },
  {
    image: "/years/EXP0000-149.jpg",
  },
  {
    image: "/years/EXP0000-291.jpg",
  },
  {
    image: "/years/EXP0000-293.jpg",
  },
  {
    image: "/years/EXP0000-344.jpg",
  },
];

export const lifeImages = [
  {
    image: "/life/nsl.jpeg",
  },
  {
    image: "/life/nsl-1.jpeg",
  },
  {
    image: "/life/nsl-2.jpeg",
  },
  {
    image: "/life/nsl-3.jpeg",
  },
  {
    image: "/life/nsl-4.jpeg",
  },
];

export const fieldImages = [
  {
    image: "/field/Untitled00086464.jpg",
  },
  {
    image: "/field/Untitled00086520.jpg",
  },
  {
    image: "/field/Untitled00086549.jpg",
  },
  {
    image: "/field/Untitled00087015.jpg",
  },
  {
    image: "/field/Untitled00087113.jpg",
  },
  {
    image: "/field/Untitled00087150.jpg",
  },
  {
    image: "/field/Untitled00087249.jpg",
  },
  {
    image: "/field/Untitled00087292.jpg",
  },
  {
    image: "/field/Untitled00087352.jpg",
  },
  {
    image: "/field/Untitled00087450.jpg",
  },
];

export const farmerImages = [
  {
    image: "/farmer/C000e40.jpg",
  },
  {
    image: "/farmer/C0qw0040.jpg",
  },
  {
    image: "/farmer/C000re40.jpg",
  },
  {
    image: "/farmer/C00tr040.jpg",
  },
  {
    image: "/farmer/C00w040.jpg",
  },
  {
    image: "/farmer/C00040.jpg",
  },
  {
    image: "/farmer/C00050.jpg",
  },
  {
    image: "/farmer/C00070.jpg",
  },
  {
    image: "/farmer/C00090.jpg",
  },
  {
    image: "/farmer/C000120.jpg",
  },
  {
    image: "/farmer/Cqw00040.jpg",
  },
];
